import { Consumer } from 'src/domain/consumer';
import { Creator } from 'src/domain/creator';
import { Organization } from 'src/domain/organization';
import { getPrimaryRole, getUserRoleLabel } from 'src/domain/user';
import { useAvatar } from 'src/view/hooks/useAvatar';
import { SelectorOption } from '../SelectorOption';

type Props = {
    onClick: () => void;
    isSelected: boolean;
    isLight?: boolean;
    variant?: 'default' | 'sidebar';
    user: Consumer | Creator | Organization;
    name?: string;
    entity?: string;
    avatarUrl?: string;
};
export const UserSelectorOption = ({
    onClick,
    isSelected,
    user,
    isLight = false,
    variant,
    name,
    entity,
    avatarUrl,
}: Props) => {
    const {
        profile: { firstName, lastName, avatar },
    } = user;
    const role = getPrimaryRole(user);
    const defaultName = [firstName, lastName].filter(Boolean).join(' ').trim();
    const displayName = name || defaultName;
    const { src, isDefault, initials } = useAvatar(
        avatarUrl ? undefined : avatar,
        {
            firstName,
            lastName,
            displayName,
        },
    );

    return (
        <SelectorOption
            onClick={onClick}
            entity={entity || getUserRoleLabel(role).toUpperCase()}
            name={displayName}
            src={avatarUrl || src}
            status="Aktiv"
            isLight={isLight}
            variant={variant}
            isSelected={isSelected}
            rounded
            isDefault={avatarUrl ? false : isDefault}
            initials={initials}
        />
    );
};
